import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { MIN_WIDTH } from 'utils/constants';
import { HIGHLIGHT_COLOR } from 'components/Benchmarks/utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  min-width: calc(${MIN_WIDTH} + 32px);
  background-color: ${colors.white};
  min-height: 100%;
`;

export const LoaderWrapper = styled.div`
  background-color: ${colors.white};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SectionWrapper = styled.div`
  display: flex;
  padding: 0 32px;
  width: 100%;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  display: flex;
  width: 100%;
  background-color: ${HIGHLIGHT_COLOR};
  padding: 32px;
  justify-content: center;
`;

export const TableSection = styled.div`
  display: flex;
  padding: 32px;
  background-color: ${colors.white};
  width: 1135px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;
